(function () {
  function slugify(text) {
    return (text || "")
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getHeaderHeight() {
    var header =
      document.querySelector("header.header") ||
      document.querySelector("#shopify-section-header") ||
      document.querySelector("header") ||
      null;

    return header ? header.getBoundingClientRect().height : 120;
  }

  function buildTOC() {
    var toc = document.querySelector("[data-testament-toc]");
    if (!toc) return;

    var contentRoot =
      document.querySelector(".testament-content-col") ||
      document.querySelector("main") ||
      document;

    var headings = Array.from(contentRoot.querySelectorAll(".testament-block-title"));
    toc.innerHTML = "";

    if (!headings.length) {
      toc.innerHTML = "<li>No sections yet.</li>";
      return;
    }

    headings.forEach(function (h) {
      var title = (h.textContent || "").trim();
      if (!title) return;

      if (!h.id) {
        var base = slugify(title) || "section";
        var id = base;
        var n = 1;

        while (document.getElementById(id)) {
          n += 1;
          id = base + "-" + n;
        }

        h.id = id;
      }

      var li = document.createElement("li");
      var a = document.createElement("a");

      a.href = "#" + h.id;
      a.textContent = title;

      li.appendChild(a);
      toc.appendChild(li);
    });

    setupClickScroll(toc);
    setupScrollSpy(headings, toc);
  }

  function setupClickScroll(toc) {
    toc.addEventListener("click", function (e) {
      var a = e.target.closest("a");
      if (!a) return;

      var id = (a.getAttribute("href") || "").slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target) return;

      e.preventDefault();

      var offset = Math.round(getHeaderHeight() + 16);
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: top, behavior: "smooth" });
    });
  }

  function setupScrollSpy(headings, toc) {
    var links = Array.from(toc.querySelectorAll("a"));
    var map = new Map();

    links.forEach(function (a) {
      var id = (a.getAttribute("href") || "").slice(1);
      if (id) map.set(id, a);
    });

    function clearActive() {
      links.forEach(function (a) {
        a.classList.remove("is-active");
      });
    }

    function makeObserver() {
      var offset = Math.round(getHeaderHeight() + 36);

      return new IntersectionObserver(
        function (entries) {
          var visible = entries
            .filter(function (e) { return e.isIntersecting; })
            .sort(function (a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });

          if (!visible.length) return;

          var id = visible[0].target.id;
          var link = map.get(id);
          if (!link) return;

          clearActive();
          link.classList.add("is-active");
        },
        {
          root: null,
          threshold: [0.2, 0.35, 0.5],
          rootMargin: "-" + offset + "px 0px -60% 0px"
        }
      );
    }

    var io = makeObserver();

    headings.forEach(function (h) {
      io.observe(h);
    });

    window.addEventListener("resize", function () {
      io.disconnect();
      io = makeObserver();

      headings.forEach(function (h) {
        io.observe(h);
      });
    });
  }

  function setupStickyTOC() {
    var article = document.querySelector("[data-testament-article]");
    var sticky = document.querySelector("[data-testament-toc-sticky]");
    var slot = document.querySelector("[data-testament-toc-slot]");
    var tocCol = document.querySelector(".testament-toc-col");

    if (!article || !sticky || !slot || !tocCol) return;

    var topGap = 44;
    var bottomBuffer = 90;

    var pinned = { left: 0, width: 0 };
    var navOpen = false;
    var navCloseTimer = null;

    function pinToSlot() {
      var r = slot.getBoundingClientRect();
      pinned.left = r.left;
      pinned.width = r.width;
    }

    function setTopVar() {
      var offset = Math.round(getHeaderHeight() + 16 + topGap);

      document.documentElement.style.setProperty(
        "--testament-sticky-top",
        offset + "px"
      );

      return offset;
    }

    function hideTOC() {
      navOpen = true;
      tocCol.classList.add("is-nav-open");
    }

    function showTOCWithDelay() {
      if (navCloseTimer) window.clearTimeout(navCloseTimer);

      navCloseTimer = window.setTimeout(function () {
        navOpen = false;
        tocCol.classList.remove("is-nav-open");
        onScroll();
      }, 220);
    }

    function setStatic() {
      sticky.classList.remove("is-fixed");
      sticky.style.left = "";
      sticky.style.width = "";
      sticky.style.transform = "";
      slot.style.height = "";
    }

    function setFixed() {
      sticky.classList.add("is-fixed");
      sticky.style.left = pinned.left + "px";
      sticky.style.width = pinned.width + "px";
      sticky.style.transform = "";
      slot.style.height = sticky.offsetHeight + "px";
    }

    function setReleasedTranslateY(y) {
      sticky.classList.remove("is-fixed");
      sticky.style.left = "";
      sticky.style.width = "";
      sticky.style.transform = "translateY(" + Math.max(0, y) + "px)";
      slot.style.height = sticky.offsetHeight + "px";
    }

    function onScroll() {
      if (navOpen) {
        setStatic();
        return;
      }

      if (window.matchMedia("(max-width: 990px)").matches) {
        setStatic();
        return;
      }

      var offset = setTopVar();
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      var aRect = article.getBoundingClientRect();

      var articleTop = scrollY + aRect.top;
      var articleBottom = scrollY + aRect.bottom;

      var stickyHeight = sticky.offsetHeight;

      var start = articleTop + topGap;
      var end = articleBottom - stickyHeight - topGap - bottomBuffer;

      var current = scrollY + offset;

      if (current < start) {
        setStatic();
        return;
      }

      if (current >= start && current < end) {
        setFixed();
        return;
      }

      var y = end - start;
      setReleasedTranslateY(y);
    }

    function onResize() {
      pinToSlot();
      onScroll();
    }

    function setupNavHoverHide() {
      var header =
        document.querySelector("header.header") ||
        document.querySelector("#shopify-section-header") ||
        document.querySelector("header");

      if (!header) return;

      header.addEventListener("pointerenter", hideTOC);
      header.addEventListener("pointerdown", hideTOC);
      header.addEventListener("focusin", hideTOC);

      header.addEventListener("pointerleave", showTOCWithDelay);
      header.addEventListener("focusout", showTOCWithDelay);
    }

    pinToSlot();
    setupNavHoverHide();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    window.addEventListener("load", onResize);

    onScroll();
  }

  document.addEventListener("DOMContentLoaded", function () {
    buildTOC();
    setupStickyTOC();
  });
})();